/* eslint-disable no-template-curly-in-string */
export function filterDropDownOptions(input, option) {
    return option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0;
}
